import { useInlineStatusQuery } from "@octopusdeploy/octopus-react-client";
import { ArgoCDAnnotationKeys } from "@octopusdeploy/octopus-server-client";
import type { ArgoCDApplicationResource, GetArgoCDInstanceSummariesResponse } from "../../../../../../packages/octopus-server-client/src/index";
export type ArgoCdInstancesAndApplications = {
    instances: GetArgoCDInstanceSummariesResponse;
    applications: ArgoCDApplicationResource[];
};
export function useArgoCDContext() {
    return useInlineStatusQuery(async (repository) => {
        const instances = await repository.ArgoCDInstances.list();
        const applicationsFetchPromises = instances.Resources.map((instance) => repository.ArgoCDGateways.listApps(instance.GatewayId));
        const applications = await Promise.all(applicationsFetchPromises);
        const flattenedApps = applications.reduce((accumulator, value) => accumulator.concat(value), []) ?? [];
        return { instances, applications: flattenedApps };
    }, [], "List Argo CD instances");
}
export function isAnnotatedForProject(application: ArgoCDApplicationResource, projectSlug: string): boolean {
    return application.Annotations?.[ArgoCDAnnotationKeys.Project] === projectSlug;
}
